<!-- 
Flat icon button with a tooltip and (optional) text

If the default slot has text in it then it will display as a button with text and icon on screens md and up.
If there is nothing in the default slot, or if the screen is sm or xs, then it will display as an icon button.
Mainly used for buttons on tables (refresh, export etc).
-->
<template>
  <v-tooltip top>
    <v-btn 
      slot="activator"
      :disabled="disabled"
      :loading="loading"
      :icon="iconOnly"
      :class="buttonCss"
      flat color="primary" 
      @click="$emit('click')"
    >
      <v-icon :class="iconCss">{{ icon }}</v-icon>
      <slot v-if="!iconOnly" />
    </v-btn>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    iconClass: {
      type: String,
      default: ""
    },
    tooltip: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasSlot() {
      return !!this.$slots.default;
    },
    iconOnly() {
      return !this.hasSlot || this.$vuetify.breakpoint.smAndDown;
    },
    iconCss() {
      return `${this.iconClass} ${!this.iconOnly ? "mr-2" : ""}`;
    },
    buttonCss() {
      return !this.iconOnly ? "pl-2 pr-3" : "";
    }
  }
};
</script>
